export default {
    "View": "Voir",
    "You cannot create more sources for this project.": "Vous ne pouvez pas créer plus de sources pour ce projet.",
    "Add a live video source": "Ajouter une source vidéo en direct",
    "Add a media": "Ajouter un média",

    "Add a distribution channel": "Ajouter une chaîne de distribution",

	"You can create up to 10 <strong>\"Media\" sources</strong>.": "Vous pouvez créer jusqu'à 10 sources \"Média\".",
	"You can create up to <strong>6 \"Live\" sources</strong>.": "Vous pouvez créer jusqu'à 6 sources \"Live\".",


    // FCreatorTabs
    "Are you sure you want to remove": "Êtes-vous sûr de vouloir supprimer",
    "Cancel": "Annuler",
    "Remove": "Supprimer",
    
    // Template
    "Add": "Ajouter",
    "Activer": "Enable",
    "Contact sales": "Nous contacter",
    "Available on demand": "Disponible sur demande"
}
